import {
  validateName,
  validateEmail,
  validateLoginPassword,
} from "../../../../common/dependencies/utils/validation";

export default {
  validateLoginForm: (params) => {
    const { username, password } = params;
    let formStatus = {};
    const usernameStatus = validateEmail(username);
    const passwordStatus = validateLoginPassword(password);
    formStatus = {
      username: usernameStatus.error,
      password: passwordStatus.error,
      hasErrors: usernameStatus.hasError || passwordStatus.hasError,
    };
    return formStatus;
  },

  validateForgotPasswordForm: (params) => {
    const { email_Id } = params;
    let formStatus = {};
    const emailIdStatus = validateEmail(email_Id);

    formStatus = {
      email_Id: emailIdStatus.error,
      hasErrors: emailIdStatus.hasError,
    };
    return formStatus;
  },
};
